import { Modal } from 'antd';
import { ReactNode } from 'react';
import { NBgIcon } from '../microcomponents/NBgIcon';
import { IconSvgElement } from '@hugeicons/react';
import { NButton } from '../microcomponents/NButton';

export interface NModalProps {
  open: boolean,
  onClose: () => void,
  color?: 'primary' | 'blue' | 'green' | 'red' | 'black',
  icon?: ReactNode,
  title?: string,
  subtitle?: string,
  text?: string,
  children?: ReactNode,
  confirmButtonText?: string,
  customFooter?: ReactNode,
  hideConfirmButton?: boolean,
  hideCancelButton?: boolean,
  cancelButtonText?: string,
  width?: number,
  hideIcon?: boolean
  disabled?: boolean,
  footerLeftComponent?: ReactNode,
  hugeIcon?: IconSvgElement,
  onConfirm?: () => void,
  loading?: boolean
}


export const NModal = ({
                         open,
                         onClose,
                         color = 'black',
                         icon,
                         title,
                         subtitle,
                         text,
                         children,
                         confirmButtonText = 'Conferma',
                         customFooter,
                         hideConfirmButton = false,
                         hideCancelButton = false,
                         cancelButtonText = 'Annulla',
                         width = 350,
                         hideIcon = false,
                         disabled = false,
                         footerLeftComponent = <div />,
                         hugeIcon,
                         onConfirm,
                         loading = false
                       }: NModalProps) => {



  return (
    <Modal destroyOnHidden centered styles={{ content: { padding: 15, paddingTop: 8, paddingBottom: 2, borderRadius: 15 } }} width={width}
           title={<div />}
           closeIcon={false} open={open} onCancel={onClose} footer={<div />}>

      <div className={'my-3 flex gap-2 items-center'}>
        {!hideIcon && hugeIcon &&
          <NBgIcon hugeIcon={hugeIcon} icon={icon} color={'info'} size={'small'} />
        }
        <div>
          <p className={'font-semibold'}>{title}</p>
          <p className={'text-xs text-gray-500'}>{subtitle}</p>
        </div>
      </div>
      {children}
      <p className={'text-sm text-gray-500'}>{text}</p>
      {customFooter ? customFooter :
        <div className={'flex justify-between items-center mt-6'}>
          {footerLeftComponent}
          <div className={'flex justify-end gap-2'}>
            {!hideCancelButton &&
              <NButton size={'small'} color={'transparent'} loading={loading}
                       onClick={onClose}>{cancelButtonText}</NButton>
            }
            {!hideConfirmButton &&
              <NButton size={'small'} disabled={disabled} loading={loading}
                       onClick={() => onConfirm ? onConfirm() : ''}>{confirmButtonText}</NButton>
            }
          </div>
        </div>
      }
    </Modal>
  );
};
